export default __webpack_public_path__ + "images/GW.1532da8.png";